import { CSSProperties, SxProps } from '@mui/system';

export const titleStyle: SxProps = {
  fontSize: '2.2rem',
  fontWeight: 700,
  textAlign: 'center',
  color: '#FFFFFF',
  background: '#C398D5',
  py: '1rem',
};

export const conversionStyle: SxProps = {
  fontSize: '1.8rem',
  textAlign: 'center',
  fontWeight: 700,
  my: '1rem',
};

export const NoticeStyle: SxProps = {
  background: '#F9F9F9',
  textAlign: 'center',
  padding: '1rem 6rem',
};

export const NoticeTitleStyle: SxProps = {
  fontSize: '1.6rem',
  fontWeight: 700,
};

export const NoticeMessageStyle: SxProps = {
  fontSize: '1.6rem',
  fontWeight: 500,
  marginTop: '1rem',
  textAlign: 'left',
};

export const NoticeEmphasisMessageStyle: CSSProperties = {
  fontSize: '1.6rem',
  fontWeight: 700,
  color: '#E91212',
};
